import { PRICE_RANGE_FILTER_CONFIG } from './searchFilterConstants'

const getPriceFilterGenerator = (values: string[]) => {
  const priceFilter: string[] = []
  values.forEach(value => {
    priceFilter.push(...PRICE_RANGE_FILTER_CONFIG[value])
  })
  return priceFilter
}

export const NUMERIC_FILTER_GENERATOR_MAP: Record<string, (values: string[]) => string[]> = {
  prices: getPriceFilterGenerator,
}
